// import { authRequired } from "app/features/auth/auth-modal/auth-modal.slice";
// import { store } from "app/store";

import { detectLang } from '../../../lib/local/local';
import { HttpClient, HttpRequest } from '../http-client';

// import { isAuthRequiredEvent } from "./events/is-auth-required";

const addUserLang = (request: HttpRequest) => {
  const lang = detectLang();
  request.headers.set('Accept-Language', lang);

  return request;
};

export const apiClient = new HttpClient({
  log: () => {
    /**/
  },
  prepareRequest: [addUserLang],
});

// @FIXME rewrite to AuthService
// legacy transition - moving from redux to mobx
// apiClient.on(isAuthRequiredEvent, () => store.dispatch(authRequired()));
